<template>
  <div class="machine-user">
    <search-user-machine
      v-on:onSubmit="onSubmit"
      v-on:resetSearch="resetSearch"
      v-on:batchRenewal="batchRenewal"
      v-on:batchManage="batchManage"
      v-on:recoverMachine="recoverMachine"
      @handlerBackAll="handlerBackAll"
      :selectList="selectList"
      :rentStateList="rentStateList"
      :search="search"
      :yesNo="yesNo"
      :isRenewal="isRenewal"
      :allColumnsList="allColumnsList"
      @handlerChangeColumns="handlerChangeColumns"
    >
    </search-user-machine>
    <add-advert-group
      ref="addAdvertGroup"
      :advertGroup="advertGroup"
      :showType="showType"
      :dialogAdvertGroup="dialogAdvertGroupRela"
      :configType="'equipment'"
      :equipmentId="currentEquipmentId"
      v-on:cancel="cancelAdvertGroupRela"
      v-on:add-advert="handleAddAdvert"
    >
    </add-advert-group>
    <add-adverts :adverts="adverts" :dialogAdverts.sync="dialogAdverts" @cancel="handleAdvertCancel" />
    <edit-user-machine
      :dialogUserMachine="dialogUserMachine"
      :machineGroup="machineGroup"
      :yesNo="yesNo"
      :deviceMode="modeList"
      v-on:cancel="cancel"
      :userEquipment="userEquipment"
    >
    </edit-user-machine>
    <config-user-machine
      :deviceMode="modeList"
      :dialogConfigMachine="dialogConfigMachine"
      :yesNo="yesNo"
      :advertPlayMode="advertPlayMode"
      v-on:cancel="configCancel"
      :userEquipment="ConfigSubmit"
      :biaoshi="0"
      :ageDevice="ageDevice"
      :feelLock="feelLock"
      :ageType="ageType"
      :priorityMode="priorityMode"
      :IdcardCountry="IdcardCountry"
    >
    </config-user-machine>
    <user-machine-line-product
      :userEquipment="userEquipment"
      v-on:lineProductCancel="lineProductCancel"
      :dialogMachineLineProduct="dialogMachineLineProduct"
    >
    </user-machine-line-product>
    <user-machine-maps
      :userEquipment="userEquipment"
      v-on:mapsCancel="mapsCancel"
      :dialogMachineMaps="dialogMachineMaps"
    >
    </user-machine-maps>
    <machine-renewal
      :nickName="nickName"
      :renewalList="selectList"
      v-on:cancelRenewal="cancelRenewal"
      :dialogBatchRenewal="dialogBatchRenewal"
    ></machine-renewal>
    <payment
      :payment="payment"
      :yesNo="yesNo"
      :shuaKaQi="shuaKaQi"
      :coinAcceptorItem="coinAcceptorItem"
      :billAcceptorItem="billAcceptorItem"
      v-on:cancelPayment="cancelPayment"
      :dialogPayment="dialogPayment"
    >
    </payment>
    <div class="table vue-padding">
      <el-table
        v-loading="loading"
        :empty-text="$t('common.noData')"
        :element-loading-text="$t('common.loading')"
        @selection-change="handleSelectionChange"
        :row-class-name="tableRowClassName"
        :data="userMachineList"
        style="width: 100%"
        max-height="668"
        :border="true"
        row-key="id"
        @sort-change="sortChange"
      >
        <el-table-column :selectable="selectable" type="selection" width="40" :align="'center'"></el-table-column>
        <el-table-column
          fixed="left"
          prop="equipmentNo"
          :label="$t('machineUser.equipmentNo')"
          width="140"
          :align="'center'"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="userName"
          :label="$t('machineUser.userName')"
          width="200"
          :align="'center'"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="teamName"
          :label="$t('machineUser.userMachineGroupName')"
          width="140"
          :align="'center'"
          sortable="custom"
        >
          <template #default="scope">
            {{ scope.row.userEquipmentTeam && scope.row.userEquipmentTeam.name }}
          </template>
        </el-table-column>
        <el-table-column
          prop="equipmentName"
          :label="$t('machineUser.name')"
          width="180"
          :align="'center'"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="mqState"
          :label="$t('machineUser.online')"
          width="90"
          :align="'center'"
          sortable="mqState"
        >
          <template slot-scope="scope">
            <template v-if="scope.row.mqState == 1">
              <div style="display: flex; justify-content: center; align-items: center">
                <el-image style="width: 10px; height: 10px" :src="require('_as/zaixian.png')" fit="fill"></el-image>
                <div style="margin-left: 5px; color: rgb(103, 194, 58); font-size: 13px">
                  {{ $t("machineUser.onlinelabel1") }}
                </div>
              </div>
            </template>

            <template v-else-if="scope.row.mqState == 0">
              <div style="display: flex; justify-content: center; align-items: center">
                <el-image style="width: 10px; height: 10px" :src="require('_as/lixian.png')" fit="fill"></el-image>
                <div style="margin-left: 5px; color: #f56c6c; font-size: 13px">
                  {{ $t("machineUser.onlinelabel2") }}
                </div>
              </div>
            </template>
            <template v-else-if="!scope.row.mqState">
              <div style="display: flex; justify-content: center; align-items: center">
                <div
                  style="
                    width: 10px;
                    height: 10px;
                    background-color: #dcdfe6;
                    border-radius: 100%;
                    border: 2px solid #909399;
                  "
                ></div>
                <div style="margin-left: 5px; font-size: 13px">
                  {{ $t("machineUser.onlinelabel3") }}
                </div>
              </div>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          prop="mqTime"
          :label="$t('user.MachineUser.993115-0')"
          width="200"
          :align="'center'"
        ></el-table-column>

        <el-table-column
          v-if="nowAddColumns.includes('isFaultLock')"
          prop="config.info.isFaultLock"
          :label="$t('editUserMachine.isLock')"
          width="190"
          :align="'center'"
        >
          <template slot-scope="scope">
            <span style="color: #67c23a" v-if="scope.row.lockState == 0">{{ $t("operation.normal") }}</span>
            <el-tag @click="handleUnlock(scope.row)" type="danger" v-if="scope.row.lockState == 1">{{
              $t("operation.unlock")
            }}</el-tag>
            <span style="color: #f56c6c" v-if="scope.row.lockState == 2">{{ $t("operation.abnormal") }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="nowAddColumns.includes('faultNum')"
          prop="faultNum"
          :label="$t('editUserMachine.hddetail')"
          width="190"
          :align="'center'"
        >
          <template slot-scope="scope">
            <div
              @click="changeNowMachineNo(scope.row, scope.$index)"
              style="height: 60px; display: flex; align-items: center; color: white; justify-content: center"
            >
              <div
                @click="colorShow(1)"
                :style="
                  'width: ' +
                  scope.row.faultNumWidth +
                  'px; height: 34px; line-height: 34px; background-color: #555555; cursor: pointer;'
                "
              >
                {{ scope.row.faultNum }}
              </div>
              <div
                @click="colorShow(2)"
                :style="
                  'width: ' +
                  scope.row.stockOutNumWidth +
                  'px; height: 34px; line-height: 34px; background-color: #E44D60; cursor: pointer;'
                "
              >
                {{ scope.row.stockOutNum }}
              </div>
              <div
                @click="colorShow(3)"
                :style="
                  'width: ' +
                  scope.row.stockAlertNumWidth +
                  'px; height: 34px; line-height: 34px; background-color: #F1C901; cursor: pointer;'
                "
              >
                {{ scope.row.stockAlertNum }}
              </div>
              <div
                @click="colorShow(4)"
                :style="
                  'width: ' +
                  scope.row.stockNormalNumWidth +
                  'px; height: 34px; line-height: 34px; background-color: #09BB07; cursor: pointer;'
                "
              >
                {{ scope.row.stockNormalNum }}
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="servicePhone"
          :label="$t('editUserMachine.servicePhone')"
          :show-overflow-tooltip="true"
          width="140"
          :align="'center'"
        ></el-table-column>

        <el-table-column
          v-if="nowAddColumns.includes('enableStatus')"
          prop="enableStatus"
          :label="$t('machineUser.enableStatus')"
          :formatter="enableStatus"
          width="80"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          v-if="nowAddColumns.includes('isDebug')"
          prop="config.info.isDebug"
          :label="$t('machineUser.isDebug')"
          :formatter="isDebug"
          width="130"
          :align="'center'"
        ></el-table-column>
        <!-- 
        <el-table-column
          v-if="nowAddColumns.includes('isBlue')"
          prop="config.remote.isBlue"
          :label="$t('machineUser.isRemoteControl')"
          :formatter="isRemoteControl"
          width="130"
          :align="'center'"
        ></el-table-column>

        <el-table-column
          v-if="nowAddColumns.includes('isHaptic')"
          prop="config.remote.isHaptic"
          :label="$t('machineUser.isFeelControl')"
          :formatter="isFeelControl"
          width="210"
          :align="'center'"
        ></el-table-column> -->

        <el-table-column
          v-if="nowAddColumns.includes('isSms')"
          prop="config.info.isSms"
          :label="$t('machineUser.isSms')"
          :formatter="isSms"
          width="100"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          v-if="nowAddColumns.includes('locale')"
          prop="locale"
          :label="$t('addUser.address')"
          width="100"
          :align="'center'"
        ></el-table-column>
        <el-table-column prop="expireDate" :label="$t('machineUser.expireDate')" width="155" :align="'center'">
          <template slot-scope="scope">
            <span class="renew" v-if="scope.row.rentState === 1">{{ $t("machineUser.renewing") }}</span>
            <span v-else :class="scope.row.isOutDate <= 0 ? 'maturity' : ''">{{ isOutDate(scope.row) }}</span>
          </template>
        </el-table-column>

        <el-table-column fixed="right" :label="$t('common.operate')" :width="rightWidth">
          <template slot-scope="scope">
            <template v-if="scope.row.isTransfer === 0">
              <div style="display: flow-root">
                <el-link
                  type="info"
                  icon="el-icon-edit"
                  v-hasPerm="['user:machine:update']"
                  @click="editUserMachine(scope.row)"
                  style="margin-right: 15px; line-height: 32px"
                  >{{ $t("common.edit") }}</el-link
                >
                <el-link
                  type="primary"
                  icon="el-icon-s-goods"
                  v-hasPerm="['machine:line:product:update']"
                  @click="machineLineProduct(scope.row)"
                  style="margin-right: 15px; line-height: 32px"
                  >{{ $t("machineUser.lineProduct") }}</el-link
                >
                <el-link
                  type="success"
                  icon="el-icon-bank-card"
                  v-hasPerm="['user:machine:payment']"
                  @click="payType(scope.row)"
                  style="margin-right: 15px; line-height: 32px"
                  >{{ $t("machineUser.payType") }}</el-link
                >
                <el-link
                  type="warning"
                  icon="el-icon-s-finance"
                  @click="machineRetainer(scope.row)"
                  style="margin-right: 15px; line-height: 32px"
                  >{{ $t("machineUser.retainer") }}</el-link
                >
                <template v-if="scope.row.machineVersion == 3">
                  <el-popover placement="left-start" :title="$t('machineUser.lywlpz')" trigger="click">
                    <div v-loading="qrloading" style="width: 200px; text-align: center">
                      <img :src="pzqrcode" style="width: 200px" @load="imgLoad" />
                      <div>{{ $t("machineUser.lywlpztips") }}</div>
                    </div>
                    <el-link
                      type="primary"
                      icon="el-icon-mobile-phone"
                      :id="'fz' + scope.$index"
                      slot="reference"
                      :data-clipboard-text="scope.row.twoCode"
                      @click="handleShowNet(scope.row, scope.$index)"
                      style="margin-right: 15px; line-height: 32px"
                      >{{ $t("machineUser.lywlpz") }}</el-link
                    >
                  </el-popover>
                </template>
                <el-link
                  type="success"
                  icon="el-icon-location"
                  v-hasPerm="['user:equipment:position']"
                  @click="machineMaps(scope.row)"
                  style="margin-right: 15px; line-height: 32px"
                  >{{ $t("machineUser.devicePosition") }}</el-link
                >
                <el-link
                  type="warning"
                  icon="el-icon-mouse"
                  v-hasPerm="['user:equipment:oneconfig']"
                  @click="handleConfig(scope.row)"
                  style="margin-right: 15px; line-height: 32px"
                  >{{ $t("machineUser.yijianConfig") }}</el-link
                >
                <el-link
                  type="primary"
                  icon="el-icon-s-tools"
                  v-hasPerm="['user:equipment:config']"
                  @click="configUserMachine(scope.row)"
                  style="margin-right: 15px; line-height: 32px"
                  >{{ $t("machineUser.mConfig") }}</el-link
                >
                <el-link
                  icon="el-icon-reading"
                  type="success"
                  @click="advertConfig(scope.row)"
                  style="margin-right: 15px; line-height: 32px"
                  >{{ $t("user.MachineUser.9398851-0") }}</el-link
                >
                <el-link
                  icon="el-icon-star-on"
                  type="primary"
                  @click="handlerScore(scope.row)"
                  style="margin-right: 15px; line-height: 32px"
                  >{{ $t("user.MachineUser.9398851-1") }}</el-link
                >
              </div>
            </template>
            <template v-else>{{ $t("machineUser.transfer") }}</template>
          </template>
        </el-table-column>
      </el-table>
      <el-row v-if="userMachineList.length > 0" style="display: flex; align-items: flex-end">
        <el-col :span="16">
          <div class="sekuai_tip" v-if="nowAddColumns.includes('faultNum')">
            <span style="color: #ff0000; font-weight: bolder">{{ $t("machineUser.tishi") }}</span
            >{{ $t("machineUser.daibiao") }}
            <div class="sekuai">{{ $t("machineUser.guzhang") }}</div>
            <div class="sekuai">{{ $t("machineUser.wuhuo") }}</div>
            <div class="sekuai">{{ $t("machineUser.quehuo") }}</div>
            <div class="sekuai">{{ $t("machineUser.zhengchang") }}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <el-pagination
            background
            layout="total,sizes,prev, pager, next,jumper"
            :current-page="page.pageIndex"
            :total="page.totalSize"
            :page-size="page.pageSize"
            @size-change="sizeChange"
            @current-change="currentChange"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
    <!-- 货道新增字段弹窗 -->
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      v-loading="loading"
      :visible.sync="colorDialog"
      :close-on-click-modal="false"
      width="600px"
      custom-class="eCigarette"
      top="6vh"
    >
      <template #title>
        <div style="color: white; font-weight: bolder; display: flex; align-items: center">
          <span
            v-if="colorType == 1"
            class="el-icon-warning"
            style="margin-right: 4px; font-size: 20px; color: #555555"
          ></span>
          <span
            v-if="colorType == 2"
            class="el-icon-warning"
            style="margin-right: 4px; font-size: 20px; color: #e44d60"
          ></span>
          <span
            v-if="colorType == 3"
            class="el-icon-warning"
            style="margin-right: 4px; font-size: 20px; color: #f1c901"
          ></span>
          <span
            v-if="colorType == 4"
            class="el-icon-success"
            style="margin-right: 4px; font-size: 20px; color: #09bb07"
          ></span>
          <div style="position: relative; display: inline-block">
            {{ errorTitle }}
            <div
              v-if="errorData.total > 0 && colorType != 4"
              style="
                font-size: 0.1rem;
                position: absolute;
                background-color: red;
                border-radius: 50%;
                top: -10px;
                right: -15px;
                width: 20px;
                height: 20px;
                text-align: center;
                line-height: 20px;
              "
            >
              {{ errorData.total }}
            </div>
          </div>
        </div>
      </template>
      <el-form ref="form" :model="form" label-position="right" label-width="150px">
        <div style="height: 500px; overflow: scroll">
          <div
            style="text-align: center; color: #aaa; margin-top: 50px"
            v-if="errorData.records && errorData.records.length == 0"
          >
            {{ $t("machineUser.dataEmpty") }}
          </div>
          <el-row
            v-for="(item, index) in errorData.records"
            :key="item.id"
            class="rowClass"
            :style="{
              borderBottom: index + 1 == errorData.records.length ? 'none' : '1px solid #ccc'
            }"
          >
            <el-col :span="11">
              <el-form-item :label="$t('machineUser.hd') + item.aisleNo + $t('machineUser.sysps')">
                <el-input
                  style="width: 60px"
                  size="small"
                  @change="handlerChange(item)"
                  v-model="item.currentInventoryLevel"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="13">
              <el-form-item :label="item.goodsName" label-width="100px">
                <div style="display: flex; align-items: center">
                  <img
                    style="height: 40px; width: 40px; margin: 0 30px 0 20px; object-fit: contain"
                    :src="item.url"
                    alt=""
                  />
                  <el-switch
                    @change="handlerChange(item)"
                    v-model="item.faultStatus"
                    :active-value="0"
                    :inactive-value="1"
                  >
                  </el-switch>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- 按钮 -->
        <div style="margin-bottom: 20px; display: flex; justify-content: space-around">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page.sync="currentColor"
            :total="+errorData.total"
            :page-size="+errorData.size"
            @current-change="handlerChangeCur"
          ></el-pagination>
        </div>
        <div style="display: flex; justify-content: space-around">
          <div class="btn" @click="handlerOneKey" v-if="this.colorType != 4">
            {{ $t("machineUser.yjcl") }}
          </div>
          <div class="btn" @click="handlerSave">
            {{ $t("helpcenter.confirm") }}
          </div>
        </div>
      </el-form>
    </el-dialog>
    <!-- 留存金 -->
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :visible.sync="retainerVisible"
      :title="$t('machineUser.lcjbt1') + retainerTitle + $t('machineUser.lcjbt2')"
      v-dialogDrag
      :close-on-click-modal="false"
      width="926px"
      custom-class="eCigarette"
      top="6vh"
    >
      <div v-loading="loadingRetainer" :element-loading-text="$t('common.request')">
        <div class="el-search vue-top-padding" style="padding: 0 0 18px 0; display: flex">
          <div
            style="
              width: 210px;
              height: 120px;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: #7770fb;
              border-radius: 8px;
              margin-right: 15px;
            "
          >
            <div style="color: white; text-align: center">
              <div style="font-size: 28px">${{ retainerInfo["sales"] }}</div>
              <div>{{ $t("retainer.ljsy") }}</div>
            </div>
          </div>
          <div
            style="
              width: 210px;
              height: 120px;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: #9570e5;
              border-radius: 8px;
              margin-right: 15px;
            "
          >
            <div style="color: white; text-align: center">
              <div style="font-size: 28px">${{ retainerInfo["cardSales"] }}</div>
              <div>{{ $t("retainer.sksy") }}</div>
            </div>
          </div>
          <div
            style="
              width: 210px;
              height: 120px;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: #605ff0;
              border-radius: 8px;
              margin-right: 15px;
            "
          >
            <div style="color: white; text-align: center">
              <div style="font-size: 28px">${{ retainerInfo["cashSales"] }}</div>
              <div>{{ $t("retainer.zbsy") }}</div>
            </div>
          </div>
          <div
            style="
              width: 210px;
              height: 120px;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: #61a5e8;
              border-radius: 8px;
            "
          >
            <div style="color: white; text-align: center">
              <div style="font-size: 28px">${{ retainerInfo["coinSales"] }}</div>
              <div>{{ $t("retainer.tbsy") }}</div>
            </div>
          </div>
        </div>
        <div style="width: 100%">
          <el-table
            :data="retainerData"
            :empty-text="$t('common.noData')"
            :element-loading-text="$t('common.loading')"
            border
            style="width: 100%"
          >
            <el-table-column
              fixed
              prop="createTime"
              :label="$t('retainer.createTime')"
              align="center"
            ></el-table-column>
            <el-table-column prop="orderNumber" :label="$t('retainer.orderNumber')" align="center"></el-table-column>
            <!-- <el-table-column prop="payType" :label="$t('retainer.payType')" align="center"></el-table-column> -->
            <el-table-column
              prop="payType"
              :label="$t('retainer.payType')"
              :formatter="formatterPayType"
              :align="'center'"
            ></el-table-column>

            <el-table-column prop="payablePrice" :label="$t('retainer.actualPrice')" align="center"></el-table-column>
          </el-table>
          <el-pagination
            v-if="retainerData.length > 0"
            background
            layout="prev, pager, next"
            :current-page="retainerPage.currentPage"
            :total="retainerPage.totalSize"
            :page-size="retainerPage.pageSize"
            @current-change="currentRetainerChange"
          ></el-pagination>
        </div>
        <!-- 操作按钮 -->
        <div
          v-if="retainerData.length > 0"
          style="
            width: 100%;
            display: flow-root;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 20px;
          "
        >
          <el-button @click="handlerCleardata" type="primary" size="medium">{{ $t("retainer.cleardata") }}</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- Add the ScoreDialog component to the template -->
    <score-dialog :visible.sync="scoreDialogVisible" :machine-info="selectedMachineInfo"></score-dialog>
  </div>
</template>

<script>
  import axios from "@/http/api";
  import searchUserMachine from "_c/machine/user/SearchUserMachine";
  import editUserMachine from "_c/machine/user/EditUserMachine";
  import configUserMachine from "_c/machine/user/ConfigUserMachine";
  import userMachineLineProduct from "_c/machine/user/UserMachineLineProduct";
  import userMachineMaps from "_c/machine/user/UserMachineMap";
  import machineRenewal from "_c/machine/user/MachineRenewal";
  import payment from "_c/machine/user/Payment";
  import Clipboard from "clipboard";
  import AddAdvertGroup from "_c/adverts/AddAdvertGroup";
  import AddAdverts from "@/components/adverts/AddAdverts.vue";
  import ScoreDialog from "./components/ScoreDialog";

  export default {
    name: "MachineUser",
    components: {
      AddAdvertGroup,
      AddAdverts,
      userMachineLineProduct,
      userMachineMaps,
      editUserMachine,
      configUserMachine,
      searchUserMachine,
      machineRenewal,
      payment,
      ScoreDialog
    },
    data() {
      return {
        scoreDialogVisible: false, // Add state for dialog visibility
        selectedMachineInfo: {}, // Add state to hold machine info for the dialog
        colorDialog: false,
        colorType: "", //当前色块
        nowEquipmentId: "", //当前machineNo
        nowIndex: "", //当前index
        currentColor: 1,
        errorTitle: "",
        errorData: {},
        errorChangeArr: [],
        loading: false,
        userMachineList: [],
        page: {
          pageSize: 10,
          pageIndex: 1
        },
        search: {
          equipmentName: "",
          equipmentNo: "",
          userName: "",
          rentState: "",
          faultStatus: "",
          enableStatus: ""
        },
        multipleSelection: [],
        yesNo: [],
        ageDevice: [],
        feelLock: [],
        ageType: [],
        priorityMode: [],
        advertPlayMode: [],
        shuaKaQi: [],
        coinAcceptorItem: [],
        billAcceptorItem: [],
        userEquipment: {
          id: "",
          uid: "",
          equipmentNo: "",
          teamId: "",
          equipmentName: "",
          userFinanceId: "",
          userFinanceMachineGroupId: "",
          scene: "",
          servicePhone: "",
          enableStatus: "",
          locale: "",
          notes: "",
          isClose: "",
          isAgeFace: "0",
          modeType: "1",
          lineProductMode: "0",
          lat: "",
          lng: "",
          vatRate: {
            isSwitch: "0",
            proportion: 0,
            type: "1",
            enableStatus: "1"
          },
          config: {
            age: {}
          }
        },
        ConfigSubmit: {
          config: {
            info: {
              isPAd: null,
              isTAd: null,
              isPTag: null,
              isFaultClose: null,
              isCoupon: null,
              isEye: null,
              isPrivacy: null,
              privacy: "",
              isSms: null,
              isFaultLock: null,
              moneySign: "",
              isGoodsMode: null
            },
            manager: {
              isOpen: null,
              isDebug: null,
              passWord: ""
            },
            remote: {
              isBlue: null,
              blueType: null,
              isHaptic: null,
              hapticType: null
            },
            model: {
              type: null,
              lockPage: null,
              isPrompt: null,
              title: "",
              message: "",
              confirm: "",
              cancel: "",
              passWord: "",
              time: []
            },
            vatRate: {
              isOpen: null,
              isCalculating: null,
              type: null,
              proportion: null
            },
            shopping: {
              isTip: null,
              tipTitle: "",
              tipMessage: "",
              tipConfirm: "",
              tipCancel: "",
              isCart: null,
              cartNum: null
            },
            age: {
              isAge: null,
              ageCamera: null,
              ageQrCode: null,
              agePriority: null,
              ageDevice: "",
              isAgeFace: null,
              ageCount: null,
              ageSDK: null,
              faceSimilarity: null,
              isSecurity: null,
              isFace: null,
              time: [],
              ageRange: null
            },
            elock: {
              isOpen: null
            },
            advert: {
              isCountdown: null,
              countdown: "",
              playMode: 0
            },
            feedback: {
              isOpen: 0,
              type: 1
            }
          },
          equipmentNo: "",
          id: "",
          verify: [],
          walletPrice: ""
        },
        dialogUserMachine: false,
        dialogConfigMachine: false,
        dialogMachineLineProduct: false,
        dialogMachineMaps: false,
        dialogDeposit: false,
        machineGroup: [],
        uId: localStorage.getItem("uId"),
        pId: localStorage.getItem("pId"),
        userDeposit: {
          userName: "",
          nickName: "",
          equipmentNo: "",
          airwayBillNo: ""
        },
        selectList: [],
        dialogBatchRenewal: false,
        dialogManage: false,
        nickName: "",
        dialogPayment: false,
        payment: {
          equipmentNo: "",
          id: "",
          payConfig: {}
        },
        modeList: [],
        rentStateList: [], //过期筛选
        IdcardCountry: [],
        pzqrcode: "",
        qrloading: false,
        //  留存金
        retainerVisible: false,
        loadingRetainer: false,
        retainerTitle: "",
        retainerPage: {
          pageIndex: 1,
          pageSize: 10,
          totalSize: 0
        },
        retainerSearch: {
          userEquipmentId: 0
        },
        retainerData: [],
        retainerInfo: {
          sales: "0.00",
          cardSales: "0.00",
          cashSales: "0.00",
          coinSales: "0.00"
        },
        payTypeList: [],
        localRetainerId: "",
        isRenewal: false,
        // 所有栏目可选项目
        allColumnsList: [
          {
            label: this.$t("editUserMachine.isLock"),
            value: "isFaultLock"
          },
          {
            label: this.$t("editUserMachine.hddetail"),
            value: "faultNum"
          },
          {
            label: this.$t("machineUser.enableStatus"),
            value: "enableStatus"
          },
          { label: this.$t("machineUser.isDebug"), value: "isDebug" },
          // {
          //   label: this.$t("machineUser.isRemoteControl"),
          //   value: "isBlue"
          // },
          // {
          //   label: this.$t("machineUser.isFeelControl"),
          //   value: "isHaptic"
          // },
          { label: this.$t("machineUser.isSms"), value: "isSms" },
          { label: this.$t("addUser.address"), value: "locale" }
        ],
        nowAddColumns: [],
        dialogAdvertGroupRela: false,
        advertGroup: {
          id: "",
          name: "",
          notes: "",
          display: ""
        },
        showType: [],
        currentEquipmentId: "",
        dialogAdverts: false,
        adverts: {
          id: "",
          advertType: "",
          showImage: "",
          showVideo: "",
          title: "",
          advertPrice: "",
          advertShopName: "",
          url: "",
          duration: 0,
          thumbnail: "",
          remarks: ""
        }
      };
    },
    mounted() {
      this.currentChange();
      this.getIdcardCountry();
      this.getYesNo();
      this.getShuaKaQi();
      this.getCoinAcceptorItem();
      this.getBillAcceptorItem();
      this.listMachineGroup();
      this.listFinance();
      this.getRenewalStatusList();
      this.getAgeDevice();
      this.getFeelLock();
      this.getAgeType();
      this.getPriorityMode();
      this.getAdvertPlayMode();
      this.listPayType();
      this.listShowType();

      // 加入是从立即续费进来的
      if (this.$route.query.rentState) {
        this.search.rentState = this.$route.query.rentState;
        this.isRenewal = true;
      }
    },
    computed: {
      rightWidth() {
        if (this.nowAddColumns && this.nowAddColumns.length < 4) {
          return 450;
        } else {
          return 365;
        }
      }
    },
    methods: {
      handlerScore(row) {
        // console.log(row);
        this.selectedMachineInfo = {
          id: row.id,
          equipmentNo: row.equipmentNo,
          equipmentName: row.equipmentName
        };
        this.scoreDialogVisible = true; // Open the dialog
      },
      cancelAdvertGroupRela(dialog, status) {
        this.dialogAdvertGroupRela = dialog;
        if (status === "update") {
          this.currentChange();
        }
      },
      handleAddAdvert() {
        this.adverts = {
          id: "",
          advertType: "",
          showImage: "",
          showVideo: "",
          title: "",
          advertPrice: "",
          advertShopName: "",
          url: "",
          duration: 0,
          thumbnail: "",
          remarks: ""
        };
        this.dialogAdverts = true;
      },
      handleAdvertCancel(dialog, action) {
        this.dialogAdverts = dialog;
        if (action === "save" || action === "update") {
          if (this.dialogAdvertGroupRela) {
            this.$nextTick(() => {
              const addAdvertGroupRef = this.$refs.addAdvertGroup;
              if (addAdvertGroupRef && typeof addAdvertGroupRef.init === "function") {
                addAdvertGroupRef.init();
              }
            });
          }
        }
      },
      listShowType() {
        this.$api.dict("gp_show_type").then(res => {
          if (res.code === 0) {
            this.showType = res.data;
          }
        });
      },
      advertConfig(row) {
        this.dialogAdvertGroupRela = true;
        this.currentEquipmentId = row.id;
        Object.keys(this.advertGroup).forEach(key => {
          this.advertGroup[key] = row[key];
        });
        this.advertGroup.id = row.id;
      },
      //留存金
      machineRetainer(row) {
        let _self = this;
        _self.retainerTitle = " " + row.equipmentNo;
        _self.retainerVisible = true;
        _self.localRetainerId = row.id;
        _self.currentRetainerChange(1, row.id);
      },
      sortChange(column) {
        if (column.order === "ascending") {
          this.search.order = "asc";
          this.search.sort = column.prop;
        } else if (column.order === "descending") {
          this.search.order = "desc";
          this.search.sort = column.prop;
        } else {
          delete this.search.sort;
          delete this.search.order;
        }
        this.page.pageIndex = 1;
        this.currentChange();
      },
      handlerChangeColumns(e) {
        this.nowAddColumns = e;
      },
      handlerBackAll() {
        this.isRenewal = false;
        this.search.rentState = "";
        this.currentChange();
      },
      // 点击色块
      colorShow(n) {
        // this.currentChange = 1;
        this.currentColor = 1;
        this.colorDialog = true;
        this.colorType = n;
        console.log(this.$t("user.MachineUser.9398851-2"), n);
        switch (n) {
          case 1:
            this.errorTitle = this.$t("machineUser.hdgzxq");
            break;
          case 2:
            this.errorTitle = this.$t("machineUser.hdjgxq");
            break;
          case 3:
            this.errorTitle = this.$t("machineUser.hdqhxq");
            break;
          case 4:
            this.errorTitle = this.$t("machineUser.zchdxq");
            break;
        }
      },
      changeNowMachineNo(row, index) {
        this.nowEquipmentId = row.id;
        this.nowIndex = index;
        // console.log(this.nowMachineNo);
        this.getColorData();
      },
      // 数据修改
      handlerChange(item) {
        if (+item.currentInventoryLevel > item.maxAllowedStock) {
          item.currentInventoryLevel = item.maxAllowedStock;
          this.$message.warning(this.$t("machineUser.szcgmax"));
          return;
        }
        // 修改后的对象装进提交数组
        let isHas = false; //查重
        this.errorChangeArr.forEach(ite => {
          if (ite.id == item.id) {
            //重复
            ite.faultStatus = item.faultStatus;
            ite.currentInventoryLevel = item.currentInventoryLevel;
            isHas = true;
          }
        });
        if (!isHas) {
          //无重复
          let obj = {
            id: item.id,
            faultStatus: item.faultStatus,
            currentInventoryLevel: item.currentInventoryLevel
          };
          this.errorChangeArr.push(obj);
        }
      },
      //一键处理
      handlerOneKey() {
        let that = this;
        let nums = "";
        this.errorData.records.forEach(item => {
          nums = nums + item.aisleNo + ",";
        });
        nums = nums.slice(0, -1);
        if (that.colorType == 1) {
          this.$confirm(
            this.$t("machineUser.cczjhkq") + nums + this.$t("machineUser.jzd1"),
            this.$t("machineUser.sfyjcl"),
            {
              confirmButtonText: this.$t("common.definite"),
              cancelButtonText: this.$t("common.cancel")
            }
          ).then(() => {
            that.errorData.records.forEach(item => {
              item.faultStatus = 0;
            });
            that.handlerSave(1);
          });
        } else {
          this.$confirm(
            this.$t("machineUser.bm1") + nums + this.$t("machineUser.jzd2"),
            this.$t("machineUser.sfyjbm"),
            {
              confirmButtonText: this.$t("common.definite"),
              cancelButtonText: this.$t("common.cancel")
            }
          ).then(() => {
            that.errorData.records.forEach(item => {
              item.currentInventoryLevel = item.maxAllowedStock;
            });
            that.handlerSave(1);
          });
        }
      },
      // 获取色块数目 修改的列表接口
      getColorNum() {
        this.loading = true;
        let obj = {
          equipmentId: this.nowEquipmentId
        };
        this.$api.request(this.$url.UserMachine.page, this.$method.get, obj).then(res => {
          if (res.code === 0) {
            // 本项就是更改了的那个 只需要拿里面的颜色数据即可
            this.userMachineList.splice(this.nowIndex, 1, res.data.records[0]);
            // 色块大小
            let faultNum = res.data.records[0]["faultNum"] ? parseInt(res.data.records[0]["faultNum"]) : 0;
            let stockOutNum = res.data.records[0]["stockOutNum"] ? parseInt(res.data.records[0]["stockOutNum"]) : 0;
            let stockAlertNum = res.data.records[0]["stockAlertNum"]
              ? parseInt(res.data.records[0]["stockAlertNum"])
              : 0;
            let stockNormalNum = res.data.records[0]["stockNormalNum"]
              ? parseInt(res.data.records[0]["stockNormalNum"])
              : 0;
            // 2.求分母
            let total = faultNum + stockOutNum + stockAlertNum + stockNormalNum;
            // 3.定义总宽度
            let totalwidth = 200;

            // 新的划分方式 修改逻辑
            //  -1 全部赋值1/10 如果>0存在的话
            let all = 10;
            let faultNum1 = 0;
            //  -2保证每一个只要存在就占比1/10
            if (faultNum > 0) {
              // 如果存在至少占0.25百分比
              faultNum1++;
              all--;
            }

            let stockOutNum1 = 0;
            if (stockOutNum > 0) {
              // 如果存在至少占0.25百分比
              stockOutNum1++;
              all--;
            }

            let stockAlertNum1 = 0;
            if (stockAlertNum > 0) {
              // 如果存在至少占0.25百分比
              stockAlertNum1++;
              all--;
            }

            let stockNormalNum1 = 0;
            if (stockNormalNum > 0) {
              // 如果存在至少占0.25百分比
              stockNormalNum1++;
              all--;
            }
            // 此时all为十份中的剩余
            if (total == 0) {
              // 总数为0 均分格子都为
              faultNum1 = 2.5;
              stockOutNum1 = 2.5;
              stockAlertNum1 = 2.5;
              stockNormalNum1 = 2.5;
            } else {
              // 剩下的色块分
              faultNum1 = faultNum1 + faultNum / all;
              stockOutNum1 = stockOutNum1 + stockOutNum / all;
              stockAlertNum1 = stockAlertNum1 + stockAlertNum / all;
              stockNormalNum1 = stockNormalNum1 + stockNormalNum / all;
            }
            res.data.records[0]["faultNumWidth"] = totalwidth * faultNum1;
            res.data.records[0]["stockOutNumWidth"] = totalwidth * stockOutNum1;
            res.data.records[0]["stockAlertNumWidth"] = totalwidth * stockAlertNum1;
            res.data.records[0]["stockNormalNumWidth"] = totalwidth * stockNormalNum1;
          }
          this.loading = false;
        });
      },
      // 确认保存
      handlerSave(oneKey = 0) {
        if (this.errorChangeArr.length <= 0 && oneKey != 1) {
          this.colorDialog = false;
          return;
        }
        this.loading = true;
        let tempData = [];
        if (oneKey == 1) {
          tempData = this.errorData.records;
        } else {
          tempData = this.errorChangeArr;
        }
        axios({
          url: this.$url.UserMachine.saveError,
          method: this.$method.put,
          headers: {
            "Content-Type": "application/json"
          },
          data: JSON.stringify(tempData)
        }).then(res => {
          this.loading = false;
          if (res.code == 0) {
            this.errorChangeArr = []; //成功后清除修改数组
            this.$message.success(res.msg);
            if (oneKey != 1) {
              //确认保存
              this.colorDialog = false;
            } else {
              this.handlerFirstCur();
            }
            // 此处确认保存已经成功 前端改变色块区域
            this.getColorNum();
          } else {
            this.$message.warning(res.msg);
          }
        });
      },
      // 首页
      handlerFirstCur() {
        this.currentColor = 1;
        this.getColorData();
      },
      // 跳页
      handlerChangeCur(e) {
        this.currentColor = e;
        this.getColorData();
      },
      getColorData() {
        this.loading = true;
        this.$api
          .request(this.$url.UserMachine.errorLook, this.$method.get, {
            equipmentId: this.nowEquipmentId,
            searchType: this.colorType,
            pageIndex: this.currentColor
          })
          .then(res => {
            this.errorData = res.data;
            this.loading = false;
          });
      },
      handlerCleardata() {
        let _self = this;
        _self
          .$confirm(_self.$t("retainer.cleardatatips"), _self.$t("common.warning"), {
            confirmButtonText: _self.$t("common.definite"),
            cancelButtonText: _self.$t("common.cancel"),
            type: "warning"
          })
          .then(() => {
            _self.$api
              .request(_self.$url.UserMachine.payRecordClear, _self.$method.post, {
                userEquipmentId: _self.localRetainerId
              })
              .then(res => {
                _self.$notify({
                  title: this.$t("common.tip"),
                  message: res.msg,
                  type: "success"
                });
                _self.currentRetainerChange(1, _self.localRetainerId);
              })
              .catch(res => {
                _self.$notify({
                  title: this.$t("common.tip"),
                  message: res.msg,
                  type: "warning"
                });
              });
          });
      },
      listPayType() {
        let _self = this;
        _self.$api.dict("gp_pay_type").then(res => {
          if (res.code === 0) {
            _self.payTypeList = res.data;
          }
        });
      },
      currentRetainerChange(pageIndex, id) {
        let _self = this;
        _self.loadingRetainer = true;
        _self.retainerPage.pageIndex = pageIndex ? pageIndex : 1;
        if (id) {
          _self.retainerSearch.userEquipmentId = id;
        }
        let obj = _self.$cloud.objMerge(_self.retainerSearch, _self.retainerPage);
        _self.$api
          .request(_self.$url.UserMachine.payRecord, _self.$method.get, obj)
          .then(res => {
            if (res.code === 0) {
              _self.retainerData = res.data.records;
              _self.retainerPage.totalSize = parseInt(res.data.total);
              if (res.data.sum) {
                _self.retainerInfo = res.data.sum;
              } else {
                _self.retainerInfo = {
                  sales: "0.00",
                  cardSales: "0.00",
                  cashSales: "0.00",
                  coinSales: "0.00"
                };
              }
            }
            _self.loadingRetainer = false;
          })
          .catch(() => {
            _self.loadingRetainer = false;
          });
      },
      // 回收设备
      recoverMachine() {
        this.$confirm(this.$t("machine.recycle"), this.$t("common.tip"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }).then(() => {
          this.$api
            .request(this.$url.Machine.userRecover, this.$method.put, {
              equipmentIds: this.$cloud.getIds(this.selectList)
            })
            .then(res => {
              console.log(res);
              let obj = JSON.parse(res.data);
              if (res.code === 0) {
                this.$notify({
                  title: this.$t("common.tip"),
                  dangerouslyUseHTMLString: true,
                  message: `number of successes:${obj.success}<br/>number of failures:${obj.error}<br/>${res.msg}`,
                  type: "success"
                });
                this.currentChange();
              }
            });
        });
      },
      // 解锁
      handleUnlock(row) {
        this.$confirm(this.$t("common.gzsptip"), this.$t("common.tip"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        })
          .then(() => {
            this.loading = true;
            this.$api
              .request(this.$url.UserMachine.update, this.$method.put, {
                teamId: row.teamId,
                id: row.id,
                isLock: 0
              })
              .then(res => {
                if (res.code === 0) {
                  this.$notify({
                    title: this.$t("common.tip"),
                    message: this.$t("common.unlockcg"),
                    type: "success"
                  });
                }
                this.loading = false;
                this.pageIndex = 1;
                this.currentChange();
              })
              .catch(() => {
                this.loading = false;
              });
          })
          .catch(() => {});
      },
      // 一键配置同款
      handleConfig(row) {
        this.$confirm(this.$t("machineUser.warnConfig"), this.$t("common.warning"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        })
          .then(() => {
            this.$api
              .request(this.$url.UserMachine.config, this.$method.post, {
                id: row.id
              })
              .then(res => {
                if (res.code === 0) {
                  this.$notify({
                    title: this.$t("common.tip"),
                    message: res.msg,
                    type: "success"
                  });
                  this.currentChange();
                } else {
                  this.$notify({
                    title: this.$t("common.tip"),
                    message: res.msg,
                    type: "error"
                  });
                }
              });
          })
          .catch(res => {
            console.log(res);
          });
      },
      tableRowClassName({ row }) {
        if (row.enableStatus == 0) {
          return "warning-row";
        }
      },
      handleSelectionChange(val) {
        this.selectList = val;
      },
      listFinance() {
        this.$api.dict("gp_user_machine_mode").then(res => {
          this.modeList = res.data;
        });
      },
      getIdcardCountry() {
        this.$api.dict("sys_idcard_country").then(res => {
          if (res.code === 0) {
            this.IdcardCountry = res.data;
          }
        });
      },
      getRenewalStatusList() {
        this.$api.dict("renewal_status").then(res => {
          if (res.code === 0) {
            this.rentStateList = res.data;
          }
        });
      },
      getYesNo() {
        this.$api.dict("sys_yes_no").then(res => {
          if (res.code === 0) {
            this.yesNo = res.data;
          }
        });
      },
      getAgeDevice() {
        this.$api.dict("age_device").then(res => {
          if (res.code === 0) {
            this.ageDevice = res.data;
          }
        });
      },
      getFeelLock() {
        this.$api.dict("feel_lock").then(res => {
          if (res.code === 0) {
            this.feelLock = res.data;
          }
        });
      },
      getAgeType() {
        this.$api.dict("age_discern_type").then(res => {
          if (res.code === 0) {
            this.ageType = res.data;
          }
        });
      },
      getPriorityMode() {
        this.$api.dict("priority_mode").then(res => {
          if (res.code === 0) {
            this.priorityMode = res.data;
          }
        });
      },
      getAdvertPlayMode() {
        this.$api.dict("advert_play_mode").then(res => {
          if (res.code === 0) {
            this.advertPlayMode = res.data;
          }
        });
      },
      getShuaKaQi() {
        this.$api.dict("sys_shua_kaqi").then(res => {
          if (res.code === 0) {
            this.shuaKaQi = res.data;
          }
        });
      },
      getCoinAcceptorItem() {
        this.$api.dict("coin_acceptor").then(res => {
          if (res.code === 0) {
            this.coinAcceptorItem = res.data;
          }
        });
      },
      getBillAcceptorItem() {
        this.$api.dict("bill_acceptor").then(res => {
          if (res.code === 0) {
            this.billAcceptorItem = res.data;
          }
        });
      },
      listMachineGroup() {
        this.$api.request(this.$url.UserMachineGroup.list, this.$method.get).then(res => {
          if (res.code === 0) {
            this.machineGroup = res.data;
          }
        });
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
        this.currentChange();
      },
      currentChange(pageIndex) {
        let _self = this;
        _self.loading = true;
        _self.page.pageIndex = pageIndex ? pageIndex : 1;
        let obj = _self.$cloud.objMerge(_self.search, _self.page);
        _self.$api
          .request(_self.$url.UserMachine.page, _self.$method.get, obj)
          .then(res => {
            if (res.code === 0) {
              let records = res.data.records;
              for (let i = 0; i < records.length; i++) {
                let isshow = false;
                if (records[i]["userFinanceId"] == _self.uId && !isshow) {
                  isshow = true;
                }
                records[i]["isshow"] = isshow;

                // 划分色块
                // 1.转数字
                let faultNum = records[i]["faultNum"] ? parseInt(records[i]["faultNum"]) : 0;
                let stockOutNum = records[i]["stockOutNum"] ? parseInt(records[i]["stockOutNum"]) : 0;
                let stockAlertNum = records[i]["stockAlertNum"] ? parseInt(records[i]["stockAlertNum"]) : 0;
                let stockNormalNum = records[i]["stockNormalNum"] ? parseInt(records[i]["stockNormalNum"]) : 0;
                // 2.求分母
                let total = faultNum + stockOutNum + stockAlertNum + stockNormalNum;
                // 3.定义总宽度
                let totalwidth = 200;

                // 新的划分方式 修改逻辑
                //  -1 全部赋值1/10 如果>0存在的话
                let all = 10;
                let faultNum1 = 0;
                //  -2保证每一个只要存在就占比1/10
                if (faultNum > 0) {
                  // 如果存在至少占0.25百分比
                  faultNum1++;
                  all--;
                }
                let stockOutNum1 = 0;
                if (stockOutNum > 0) {
                  // 如果存在至少占0.25百分比
                  stockOutNum1++;
                  all--;
                }

                let stockAlertNum1 = 0;
                if (stockAlertNum > 0) {
                  // 如果存在至少占0.25百分比
                  stockAlertNum1++;
                  all--;
                }

                let stockNormalNum1 = 0;
                if (stockNormalNum > 0) {
                  // 如果存在至少占0.25百分比
                  stockNormalNum1++;
                  all--;
                }
                // 此时all为十份中的剩余
                if (total == 0) {
                  // 总数为0 均分格子都为
                  faultNum1 = 2.5;
                  stockOutNum1 = 2.5;
                  stockAlertNum1 = 2.5;
                  stockNormalNum1 = 2.5;
                } else {
                  // 剩下的色块分
                  faultNum1 = faultNum1 + faultNum / all;
                  stockOutNum1 = stockOutNum1 + stockOutNum / all;
                  stockAlertNum1 = stockAlertNum1 + stockAlertNum / all;
                  stockNormalNum1 = stockNormalNum1 + stockNormalNum / all;
                }
                records[i]["faultNumWidth"] = totalwidth * faultNum1;
                records[i]["stockOutNumWidth"] = totalwidth * stockOutNum1;
                records[i]["stockAlertNumWidth"] = totalwidth * stockAlertNum1;
                records[i]["stockNormalNumWidth"] = totalwidth * stockNormalNum1;
              }
              _self.userMachineList = res.data.records;
              _self.page.totalSize = parseInt(res.data.total);
            }
            _self.loading = false;
          })
          .catch(() => {
            _self.loading = false;
          });
      },
      onSubmit(data) {
        this.search = data;
        this.currentChange();
      },
      resetSearch(data) {
        this.search = data;
        this.currentChange();
      },
      faultStatus(row) {
        return this.$cloud.getDictLabel(this.yesNo, row.faultStatus);
      },
      isPort(row) {
        return this.$cloud.getDictLabel(this.yesNo, row.port);
      },
      enableStatus(row) {
        console.log(row.enableStatus);
        return this.$cloud.getDictLabel(this.yesNo, row.enableStatus);
      },
      isDebug(row) {
        return this.$cloud.getDictLabel(this.yesNo, row.config.info.isDebug);
      },
      isRemoteControl(row) {
        return this.$cloud.getDictLabel(this.yesNo, row.config.remote.isBlue);
      },
      isFeelControl(row) {
        return this.$cloud.getDictLabel(this.yesNo, row.config.remote.isHaptic);
      },
      isDoubleScreen(row) {
        return this.$cloud.getDictLabel(this.yesNo, row.isDoubleScreen);
      },
      isLock(row) {
        return this.$cloud.getDictLabel(this.yesNo, row.isLock);
      },
      isSms(row) {
        return this.$cloud.getDictLabel(this.yesNo, row.config.info.isSms);
      },
      isCart(row) {
        return this.$cloud.getDictLabel(this.yesNo, row.isCart);
      },
      formatterPayType(row) {
        return this.$cloud.getDictLabel(this.payTypeList, row.payType);
      },
      isOutDate(row) {
        if (row.isOutDate <= 30 && row.isOutDate > 0) {
          return this.$t("machineUser.nExpired").replace("N", row.isOutDate);
        } else if (row.isOutDate <= 0) {
          return this.$t("machineUser.beExpired");
        }
        return row.expireDate;
      },
      editUserMachine(row) {
        Object.keys(this.userEquipment).forEach(key => {
          this.userEquipment[key] = row[key];
        });
        this.userEquipment.id = row.id;
        this.dialogUserMachine = true;
      },
      configUserMachine(row) {
        this.ConfigSubmit.config = row.config;
        this.ConfigSubmit.equipmentNo = row.equipmentNo;
        this.ConfigSubmit.id = row.id;
        this.ConfigSubmit.verify = row.verify;
        this.ConfigSubmit.walletPrice = row.walletPrice;
        this.dialogConfigMachine = true;
      },
      machineLineProduct(row) {
        this.userEquipment = row;
        this.userEquipment.id = row.id;
        this.dialogMachineLineProduct = true;
      },
      // 弹出地图弹框
      machineMaps(row) {
        this.dialogMachineMaps = true;
        Object.keys(this.userEquipment).forEach(key => {
          this.userEquipment[key] = row[key] ? row[key] : "";
        });
        this.userEquipment.id = row.id;
      },
      // 隐藏地图弹框
      mapsCancel(dialog, state) {
        this.dialogMachineMaps = dialog;
        if (state) {
          this.currentChange(this.page.pageIndex);
        }
      },
      payType(row) {
        this.dialogPayment = true;
        Object.keys(this.payment).forEach(key => {
          this.payment[key] = row[key];
        });
      },
      handleShowNet(row, index) {
        let _self = this;
        let clipboard = new Clipboard("#fz" + index);
        clipboard.on("success", e => {
          console.log(e);
          _self.$message({
            message: this.$t("userMachineLineProduct.fzcg"),
            type: "success"
          });
          clipboard.destroy();
          return false;
        });
        //  获取二维码
        _self.qrloading = true;
        this.$api
          .request(this.$url.UserMachine.getQrCode, this.$method.get, {
            path: row.twoCode
          })
          .then(res => {
            _self.pzqrcode = res.data;
          })
          .catch(() => {
            this.qrloading = false;
          });
      },
      imgLoad() {
        let _self = this;
        _self.qrloading = false;
      },
      cancel(dialog, state) {
        this.dialogUserMachine = dialog;
        if (state) {
          this.currentChange(this.page.pageIndex);
        }
      },
      configCancel(dialog, state) {
        this.dialogConfigMachine = dialog;
        if (state) {
          this.currentChange(this.page.pageIndex);
        }
      },
      // 隐藏货道商品弹框
      lineProductCancel(dialog) {
        this.dialogMachineLineProduct = dialog;
      },

      // 批量续费
      batchRenewal() {
        this.dialogBatchRenewal = true;
        this.nickName = this.selectList[0].nickName;
      },
      cancelRenewal(dialog, state) {
        this.dialogBatchRenewal = dialog;
        if (state) {
          this.currentChange(this.page.pageIndex);
        }
      },

      // 批量管理
      batchManage() {
        this.dialogManage = true;
      },
      cancelManage(dialog, state) {
        this.dialogManage = dialog;
        if (state) {
          this.currentChange(this.page.pageIndex);
        }
      },
      selectable(row) {
        return row.rentState != 1 || this.uId == row.uId;
      },
      // 支付方式弹框关闭
      cancelPayment(dialog, state) {
        this.dialogPayment = dialog;
        if (state) {
          const page = this.page.pageIndex;
          this.currentChange(page);
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .btn {
    display: inline-block;
    background-color: #02a7f0;
    color: white;
    padding: 10px 0;
    text-align: center;
    border-radius: 6px;
    width: 45%;
    cursor: pointer;
  }
  ::v-deep .el-table th {
    padding: 8px 0;
  }
  .table {
    overflow: hidden;
  }
  .table .el-table .warning-row {
    background: #f56c6c;
    color: #ffffff;
  }
  .table .el-table .hover-row {
    color: #606266;
  }
  .machine-user .image {
    position: absolute;
  }
  .machine-user .maturity {
    color: #f56c6c;
  }
  .machine-user .renew {
    color: #67c23a;
  }
  ::v-deep .eCigarette {
    border-radius: 6px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial,
      sans-serif;
    .el-dialog__header {
      padding: 15px 15px 15px 20px;
      background-color: #409eff;
      border-radius: 5px 5px 0 0;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: white;
    }
    .el-dialog__title {
      color: white;
    }
    .el-dialog__body {
      padding: 20px;
    }
    .el-form--label-top .el-form-item__label {
      padding: 0;
    }
    .el-form-item {
      margin: 0;
    }
    .el-dialog__headerbtn {
      top: 20px;
      right: 15px;
    }
  }
  .sekuai_tip {
    color: #606266;
    font-size: 0.14rem;
    display: flex;
    align-items: center;
    .sekuai {
      display: flex;
      align-items: center;
      margin-left: 10px;
      &:nth-of-type(1) {
        &::before {
          content: "";
          width: 20px;
          height: 20px;
          margin-right: 5px;
          background-color: #555555;
        }
      }
      &:nth-of-type(2) {
        &::before {
          content: "";
          width: 20px;
          height: 20px;
          margin-right: 5px;
          background-color: #e44d60;
        }
      }
      &:nth-of-type(3) {
        &::before {
          content: "";
          width: 20px;
          height: 20px;
          margin-right: 5px;
          background-color: #f1c901;
        }
      }
      &:nth-of-type(4) {
        &::before {
          content: "";
          width: 20px;
          height: 20px;
          margin-right: 5px;
          background-color: #09bb07;
        }
      }
    }
  }
  .rowClass {
    display: flex;
    justify-content: space-between;
    padding: 4px 0;
  }
</style>
